import React from "react";
import { useGame } from "../../../../../hooks/useGame.ts";
import { useShootoutDisplay } from "../../../../../hooks/useShootoutDisplay.ts";
import { TeamName } from "../../../../../Components/TeamName.tsx";
import { IconBallFootball } from "@tabler/icons-react";

interface ShootOutProps {
  gameId?: string;
  team: "home" | "guest";
}

export const ShootOut: React.FC<ShootOutProps> = (props) => {
  const { gameId, team } = props;

  const game = useGame(gameId);
  const shootout = useShootoutDisplay(gameId);

  const homeTeamId = game.data?.actualTeams.homeTeamId;
  const guestTeamId = game.data?.actualTeams.guestTeamId;

  if (!game.isSuccess || !homeTeamId || !guestTeamId || !shootout) {
    return <></>;
  }

  const { homeShots, guestShots } = shootout;
  const displayLength = Math.max(homeShots.length, guestShots.length, 1);
  const ballSize = Math.min(490 / displayLength, 90);

  const homeTeamShots = homeShots.map((success, i) => (
    <IconBallFootball
      key={i}
      color={success !== null ? (success ? "lime" : "red") : "grey"}
      size={ballSize}
    />
  ));

  const guestTeamShots = guestShots.map((success, i) => (
    <IconBallFootball
      key={i}
      color={success !== null ? (success ? "lime" : "red") : "grey"}
      size={ballSize}
    />
  ));

  return (
    <div
      style={{
        width: 720,
        height: 144,
        display: "flex",
        alignItems: "center",
        fontSize: 90,
        paddingLeft: 25,
        paddingRight: 25,
        fontWeight: 700,
        lineHeight: "144px",
      }}
    >
      <TeamName short teamId={team == "home" ? homeTeamId : guestTeamId} />
      <div
        style={{
          paddingLeft: 25,
          paddingRight: 25,
          height: 144,
          display: "flex",
          alignItems: "center",
        }}
      >
        {team == "home" ? homeTeamShots : guestTeamShots}
      </div>
    </div>
  );
};
